// react-redux imports
import { useState, MouseEventHandler } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import FlexColumn from "common/components/styled-components/FlexColumn";

// styled-components imports
import StyledOverlay from "./styled-components/StyledOverlay";
import StyledButton from "./styled-components/StyledButton";
import StyledLabel from "./styled-components/StyledLabel";

interface ImageButtonProps {
  label: string;
  selected: boolean;
  url: string;
  size?: number;
  value: string;
  onClick: MouseEventHandler;
}

function ImageButton({
  label,
  selected,
  url,
  value,
  onClick,
  size,
}: ImageButtonProps) {
  const [hover, setHover] = useState(false);
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  function hoverTrue() {
    setHover(true);
  }

  function hoverFalse() {
    setHover(false);
  }
  return (
    <FlexColumn>
      {!upDesktopScreen && <StyledLabel htmlFor={label}>{label}</StyledLabel>}
      <StyledButton
        id={label}
        value={value}
        onMouseEnter={hoverTrue}
        onMouseLeave={hoverFalse}
        selected={selected}
        url={url}
        onClick={onClick}
        size={size}
      >
        {hover && <StyledOverlay>{label}</StyledOverlay>}
        {selected && <span>{label}</span>}
      </StyledButton>
    </FlexColumn>
  );
}

export default ImageButton;
